<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-23 14:05:55
 * @LastEditTime: 2019-08-14 10:36:05
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="activityRegisterSubmit">
    <div class="page_bd page_bd_spacing">
      <div class="weui-cells weui-cells_form">
        <template v-for="item in fieldSortInfo">
          <div class="weui-cell"
               :key="item.configId"
               v-if="item.fieldType === '1001'">
            <div class="weui-cell__hd"><label class="weui-label"><span v-if="item.required"
                      class="red">*</span>{{item.fieldName}}</label></div>
            <div class="weui-cell__bd relative">
                  <input class="weui-input"
                         type="text"
                         maxlength="20"
                         v-model="item.fieldValue"
                         :placeholder="'请输入'+item.fieldName"
                         :readonly="!showCaptcha && item.fieldName === '手机号'" /> <!-- 如果是已登录状态手机号不可改 -->
            <div class="btnChangeNumber" @click="ChangeNumber" v-if="!showCaptcha && item.fieldName === '手机号'">更换手机号</div>
          </div>
          </div>
          <div class="weui-cell"
               :key="item.configId"
               v-if="showCaptcha && item.fieldName === '手机号'">
            <div class="weui-cell__hd"><label class="weui-label"><span class="red">*</span>验证码</label></div>
            <div class="weui-cell__bd">
              <input class="weui-input"
                     type="text"
                     maxlength="6"
                     v-model="captcha"
                     placeholder="请输入验证码" />
            </div>
            <div class="weui-cell__ft">
              <button type="button" class="weui-btn weui-btn_default weui-vcode-btn" :disabled="sendLock" style="width: 120px;" @click="checkMsg">{{!sendLock ? '获取验证码' : countDown + '秒后重试'}}</button>
            </div>
          </div>
          <div class="weui-cell weui-cell_textarea"
               :key="item.configId"
               v-if="item.fieldType === '1002'">
            <div class="weui-cell__hd"><label class="weui-label"><span v-if="item.required"
                      class="red">*</span>{{item.fieldName}}</label></div>
            <div class="weui-cell__bd">
              <textarea class="weui-textarea"
                        :placeholder="'请输入'+item.fieldName"
                        rows="3"
                        maxlength="100"
                        v-model="item.fieldValue"></textarea>
              <div class="weui-textarea-counter"><span>{{(item.fieldValue || '').length}}</span>/100</div>
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after"
               :key="item.configId"
               v-if="item.fieldType === '1003'">
            <div class="weui-cell__hd"><label class="weui-label"><span v-if="item.required"
                      class="red">*</span>{{item.fieldName}}</label></div>
            <div class="weui-cell__bd">
              <select class="weui-select"
                      :placeholder="'请选择'+item.fieldName"
                      v-model="item.fieldValue">
                <option value="" >请选择</option>
                <option v-for="option in item.optionConfig"
                        :key="option"
                        :value="option">{{option}}</option>
              </select>
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after"
               :key="item.configId"
               v-if="item.fieldType === '1004'">
            <div class="weui-cell__hd"><label class="weui-label"><span v-if="item.required"
                      class="red">*</span>{{item.fieldName}}</label></div>
            <div class="weui-cell__bd">
              <select class="weui-select"
                      :placeholder="'请选择'+item.fieldName"
                      multiple
                      v-model="item.fieldValue">
                <option v-for="option in item.optionConfig"
                        :key="option"
                        :value="option">{{option}}</option>
              </select>
            </div>
          </div>
        </template>
        <div class="weui-cell" v-if="salesCouponPrice > 0 && payObj != 'MERCHANT'">
          <div class="weui-cell__hd"><label class="weui-label">报名费用</label></div>
          <div class="weui-cell__bd">￥{{salesCouponPrice}}</div>
        </div>
        <div class="button-sp-area">
          <a href="javascript:;"
             class="weui-btn weui-btn_block btn-certification"
             @click="submit">{{motivateBuyTypeText ? motivateBuyTypeText : '立即报名'}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activityRegisterSubmit',
  data () {
    return {
      mallId: '', // 商场编号
      salesCouponPrice: 0, // 付款金额
      motivateBuyType: '', // 报名购买类型
      motivateBuyTypeText: '', // 报名购买类型文字(显示在按钮上)
      fieldSortInfo: [], // 报名字段
      captcha: '', // 手机验证码
      showCaptcha: true, // 是否显示验证码
      ticket: '', // 校验手机有没有发过短信的码
      sendLock: false, // 发送验证码锁定变量
      countDown: 60, // 倒计时
      isMobile: /^[1][0-9]{10}$/, // 手机号验证规则
      timeInter: '', // 定时器
      payObj: '' // 费用承担对象
    }
  },
  computed: {
    fieldConfigs () { // 报名字段(用于提交)
      let result = []
      this.fieldSortInfo.forEach(item => {
        result.push({
          configId: item.configId,
          fieldName: item.fieldName,
          fieldType: item.fieldType,
          fieldValue: item.fieldType === '1004' && typeof (item.fieldValue) === 'object' ? (item.fieldValue || []).join() : item.fieldValue,
          required: item.required,
          sort: item.sort
        })
      })
      return result
    },
    fieldConfigsValid () { // 报名字段必填项校验
      let self = this
      let result = ''
      self.fieldSortInfo.forEach(item => {
        if (item.required && !item.fieldValue && !result) {
          result = '请输入' + item.fieldName
        }
      })
      return result
    },
    mobile () { // 从表单的值中找到手机号(用于发送验证码)
      let result = ''
      this.fieldSortInfo.forEach(item => {
        if (item.fieldName === '手机号') {
          result = item.fieldValue
        }
      })
      return result
    }
  },
  activated () {
    this.getActivityInfo()
    this.getFieldSortInfo()
  },
  methods: {
    getActivityInfo () { // 获取活动信息
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/query/info',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : ''
          }
        })
        .then(res => {
          if (res.success) {
            self.mallId = res.data.mallId // 商场编号
            self.salesCouponPrice = res.data.salesCouponPrice // 付款金额
            self.motivateBuyType = res.data.motivateBuyType // 报名购买类型
            self.motivateBuyTypeText = res.data.motivateBuyTypeText // 报名购买类型文字(显示在按钮上)
            self.payObj = res.data.payObj // 支付对象(如果是商户承担，则不需要显示支付金额)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getFieldSortInfo () { // 查询活动报名字段排序信息
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/query/get/field/sort/info',
          params: {
            activityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          if (res.success) {
            res.data.forEach(item => {
              if (item.fieldType === '1003' || item.fieldType === '1004') {
                item.optionConfig = item.optionConfig.split(',') || []
              }
              /* 如果能带出手机号，说明是登录状态，不需要验证码 */
              if (item.fieldName === '手机号' && item.fieldValue) {
                self.showCaptcha = false
              }
            })
            self.fieldSortInfo = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    submit () { // 提交
      let self = this
      if (self.fieldConfigsValid) { // 校验必填项
        return self.$weui.toast(self.fieldConfigsValid, {
          duration: 2000,
          className: 'toast_text'
        })
      }
      if (self.showCaptcha && !self.captcha) {
        return self.$weui.toast('请输入验证码', {
          duration: 2000,
          className: 'toast_text'
        })
      }
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/enroll/handler',
          body: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            verificationCode: self.captcha, // 手机验证码
            fieldConfigVO: self.fieldConfigs
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              switch (res.data.enrollRedirectType) {
                case 'ENROLL_DIALOG':
                  self.$weui.dialog({
                    title: '提示',
                    content: '报名成功！',
                    className: 'custom-classname',
                    buttons: [{
                      label: '确定',
                      type: 'primary',
                      onClick: function () {
                        console.log('ok')
                        self.$router.back(-1)
                      }
                    }]
                  })
                  break
                case 'PAY':
                  let nowTime = (new Date()).getTime()
                  if (localStorage.getItem('SPREAD_PAY_TIME')) {
                    let payTime = parseInt(localStorage.getItem('SPREAD_PAY_TIME'))
                    let lessTime = nowTime - payTime
                    let needTime = 1000 * 60
                    if (lessTime <= needTime) {
                      self.$weui.dialog({
                        title: '提示',
                        content: '您1分钟内已经发起支付，如您已经支付过，请勿重复支付，如您未支付，请继续支付。',
                        className: 'custom-classname',
                        buttons: [{
                          label: '取消',
                          type: 'default',
                          onClick: function () {
                            console.log('cancel')
                          }
                        }, {
                          label: '继续支付',
                          type: 'primary',
                          onClick: function () {
                            localStorage.setItem('SPREAD_PAY_TIME', nowTime)
                            window.location.href = self.$store.state.ssoUrl + '/toPay.html?type=' + res.data.enrollRedirectType + '&buyFlag=' + res.data.buyFlag + '&tk=' + localStorage.getItem('STAR_GUEST_TOKEN')
                          }
                        }]
                      })
                    } else {
                      localStorage.setItem('SPREAD_PAY_TIME', nowTime)
                      window.location.href = self.$store.state.ssoUrl + '/toPay.html?type=' + res.data.enrollRedirectType + '&buyFlag=' + res.data.buyFlag + '&tk=' + localStorage.getItem('STAR_GUEST_TOKEN')
                    }
                  } else {
                    localStorage.setItem('SPREAD_PAY_TIME', nowTime)
                    window.location.href = self.$store.state.ssoUrl + '/toPay.html?type=' + res.data.enrollRedirectType + '&buyFlag=' + res.data.buyFlag + '&tk=' + localStorage.getItem('STAR_GUEST_TOKEN')
                  }
                  break
                default:
                  window.location.href = self.$store.state.ssoUrl + '/toPay.html?type=' + res.data.enrollRedirectType + '&buyFlag=' + res.data.buyFlag + '&tk=' + localStorage.getItem('STAR_GUEST_TOKEN')
                  break
              }
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 更换手机号
    ChangeNumber () {
      let self = this
      this.$weui.confirm('更换后将不能查看报名记录，确认更换吗？', {
        title: '提示',
        buttons: [{
          label: '取消',
          type: 'default',
          onClick: function () { console.log('取消') }
        }, {
          label: '确定',
          type: 'primary',
          onClick: function () {
            let locationHref = window.location.href
            localStorage.removeItem('IS_CIMEN_STAR_USER')
            self.$router.push({path: '/login', query: { fromurl: locationHref, type: 'change' }})
          }
        }]
      })
    },
    checkMsg () { // 检查手机号是否发送过短信
      let self = this
      if (self.isMobile.test(self.mobile) && !self.sendLock) { // 如果是手机号并且发送按钮没有锁定
        self.sendLock = true // 锁定发送
        self.$fly
          .request({
            method: 'post',
            url: '/component/wechat/login/check/and/send/msg',
            params: {
              mobile: self.mobile,
              ticket: self.ticket
            }
          })
          .then(res => {
            if (res.success) {
              self.ticket = ''
              self.countDownStart() // 发送验证码倒计时
            } else {
              self.sendLock = false // 解锁发送
              if (res.code === 20003) {
                self.ticket = res.data
                self.checkMsg() // 重新发送
              } else {
                self.$weui.toast(res.message, {
                  duration: 2000,
                  className: 'toast_text'
                })
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    countDownStart () { // 开始倒计时
      let self = this
      self.countDown = 59
      clearInterval(self.timeInter)
      self.timeInter = setInterval(function () {
        if (self.countDown > 1) {
          self.countDown--
        } else {
          self.sendLock = false
          self.countDown = 60
          clearInterval(self.timeInter)
        }
      }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#activityRegisterSubmit {
  .m-b-md {
    margin-bottom: 15px;
  }
  .page_bd {
    padding: 20px 15px;
    background-color: #fff;
  }
  .weui-cells:before {
    display: none;
  }
  .weui-cell_textarea {
    align-items: stretch;
  }
  .button-sp-area {
    padding-top: 70px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
  .btn-certification {
    background-color: #fb4e2d;
    color: #fff;
  }
  .weui-label .red {
    color: #ff000c;
  }
  .relative{
    position: relative;
  }
  .btnChangeNumber{
    padding: 10px 10px;
    border: 2px solid #5d5c5c;
    position: absolute;
    right: 10px;
    top:0;
    font-size: 24px;
    color: #5d5c5c;
    border-radius: 10px
  }
}
</style>



// WEBPACK FOOTER //
// src/views/activity/register/submit.vue